import React from 'react';

const ShopSimilarIcon = ({ width = 20, height = 20, fill = '' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        // eslint-disable-next-line max-len
        d="M11.2051 6.6665C8.69874 6.6665 6.66618 8.70027 6.66618 11.21C6.66618 13.7197 8.69874 15.7535 11.2051 15.7535C13.7114 15.7535 15.7439 13.7197 15.7439 11.21C15.7439 8.70027 13.7114 6.6665 11.2051 6.6665ZM5.66618 11.21C5.66618 8.14885 8.14559 5.6665 11.2051 5.6665C14.2645 5.6665 16.7439 8.14885 16.7439 11.21C16.7439 12.5591 16.2624 13.7957 15.4619 14.757L19.3477 18.6464L18.6403 19.3532L14.7556 15.465C13.7943 16.2693 12.5562 16.7535 11.2051 16.7535C8.14559 16.7535 5.66618 14.2712 5.66618 11.21Z"
        fill={fill}
      />
      <path d="M0 17L0 24H7V23H1V17H0Z" fill={fill} />
      <path d="M17 24H24V17H23V23H17V24Z" fill={fill} />
      <path d="M24 7V0H17V1H23V7H24Z" fill={fill} />
      <path d="M7 0H0V7H1V1H7V0Z" fill={fill} />
    </g>
  </svg>
);

export default ShopSimilarIcon;
